import { css } from "@emotion/core";

export const override = css`
  display: block;
  margin: 0 auto;
  border-color: black;
`;
